// CreateAccount.tsx
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Box, Typography, Modal, Fade } from "@mui/material";
import { useTranslation } from "react-i18next";
import Broker4XC from "assets/img/brokers/4XC.png";
import BrokerActivTrades from "assets/img/brokers/ACTIVTRADES.png";
import BrokerFortunePrime from "assets/img/brokers/FORTUNEPRIME.png";
import BrokerStarTrader from "assets/img/brokers/STARTRADER.png";

interface CreateAccountProps {
  open?: boolean;
  onClose?: () => void;
}

const CreateAccount: React.FC<CreateAccountProps> = ({
  open: propOpen,
  onClose,
}) => {
  const history = useHistory();
  const { t } = useTranslation(["tradingRobots"]);

  // Estado interno para controlar la apertura del modal
  const [open, setOpen] = useState<boolean>(
    propOpen !== undefined ? propOpen : true
  );

  // Sincronizar el estado interno con la prop 'open' si está disponible
  useEffect(() => {
    if (propOpen !== undefined) {
      setOpen(propOpen);
    }
  }, [propOpen]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setOpen(false);
      // Opcional: navegar a otra ruta si no se proporciona 'onClose'
      history.push("/");
    }
  };

  const brokerLogos = [
    {
      id: "startrader",
      src: BrokerStarTrader,
      alt: "STARTRADER",
      href: "https://www.startrader.com/es/live-account/?affid=MjQzODQwNTU=&ibpRebateCode=MjQzODQwNTVTVDEwMzU1",
    },
    {
      id: "fortuneprime",
      src: BrokerFortunePrime,
      alt: "Fortune Prime",
      href: "https://portal.fortuneprime.com/getview?view=register&token=0s9F1g",
    },
    {
      id: "activtrades",
      src: BrokerActivTrades,
      alt: "ActivTrades",
      href: "https://www.activtrades.com/es?cxd=36266_423669&affId=36266",
    },
    {
      id: "4xc",
      src: Broker4XC,
      alt: "4XC",
      href: "https://live.4xc.com/link/jirwoa",
    },
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableAutoFocus
      disableRestoreFocus
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(6px)",
      }}
    >
      <Fade in={open}>
        <Box
          bgcolor="#1F2557"
          px={4}
          py={2}
          width={300}
          minHeight={470}
          borderRadius="10px"
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          color="white"
          textAlign="center"
          lineHeight="1.2"
          position="relative"
        >
          <HighlightOffIcon
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
            }}
            onClick={handleClose}
          />
          <Typography
            component="h2"
            sx={{
              fontSize: 20,
              fontWeight: 700,
              lineHeight: 1.2,
              mt: 3,
              mb: 1,
            }}
          >
            {t("CreateAccount.title")}
          </Typography>
          <Box
            sx={{
              mt: 1,
              mb: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1.25,
            }}
          >
            {brokerLogos.map((logo) => (
              <Box
                key={logo.id}
                component="a"
                href={logo.href}
                target="_blank"
                rel="noopener noreferrer"
                referrerPolicy="no-referrer"
                sx={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "10px",
                  px: 1,
                  py: 0.5,
                  minHeight: 72,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                <Box
                  component="img"
                  src={logo.src}
                  alt={logo.alt}
                  sx={{
                    width: "100%",
                    height: "100%",
                    maxHeight: 58,
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </Box>
            ))}
          </Box>
          <Box mt={1.5} mb={0.5}>
            <Typography
              variant="body1"
              sx={{ color: "rgba(255,255,255,0.85)" }}
              fontWeight={500}
            >
              {t("CreateAccount.haveAlreadyAccount")}
            </Typography>
            <Typography
              sx={{
                cursor: "pointer",
                textDecorationLine: "underline",
                color: "#FFB04C",
              }}
              component="a"
              referrerPolicy="no-referrer"
              onClick={() => {
                handleClose();
                setTimeout(() => {
                  history.push("/tradingrobots/LinkAccount");
                }, 100);
              }}
            >
              {t("CreateAccount.linkAccountHere")}
            </Typography>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default CreateAccount;

